import {
    postGenerateInvoiceDocumentReset,
    postGenerateInvoiceDocumentLoading,
    postGenerateInvoiceDocumentSuccess,
    postGenerateInvoiceDocumentReject,
    postGenerateInvoiceDocumentRequest
} from "../../actions/invoiceProvider/postGenerateInvoiceDoc";

export const postGeneateInvoiceDocument = (formData) => async (dispatch, getState) => {
    dispatch(postGenerateInvoiceDocumentLoading());
    try {
        const { data } = await postGenerateInvoiceDocumentRequest(formData, getState);
        dispatch(postGenerateInvoiceDocumentSuccess(data))
    } catch (error) {
        dispatch(postGenerateInvoiceDocumentReject(error))
    } finally {
        setTimeout(() => { dispatch(postGenerateInvoiceDocumentReset()) }, 3000);
    }
    return Promise.resolve();
};